export default __webpack_public_path__ + "static/media/account.2412a032.svg";